// extracted by mini-css-extract-plugin
export var fadeInAnimation = "Customers-module--fadeInAnimation--5eea3";
export var icon = "Customers-module--icon--3fd50";
export var iconWrapper = "Customers-module--iconWrapper--462bb";
export var layout = "Customers-module--layout--ec806";
export var slider = "Customers-module--slider--ece43";
export var title = "Customers-module--title--b0c23";